<app-dialog-top>
    <i class="fa-solid fa-user"></i>
    {{ "ADMIN.ACCOUNTS.LABEL_ACCOUNT" | translate }}
</app-dialog-top>

<div mat-dialog-content>
    <lib-form-account-details
        class="h-100"
        [data]="data.data"
        [(readOnly)]="readOnly"
        [(submited)]="submited"
        (onClose)="close($event)"
    ></lib-form-account-details>
</div>

<app-dialog-bottom
    (onSaveClick)="onSubmit($event)"
    [saveDisabled]="readOnly"
></app-dialog-bottom>
